import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Safe16 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={16}
    contrast={contrast}
    className={className}
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.25 5.87803V4H8.75V5.87803C9.83277 6.26073 10.4608 7.44798 10.1815 8.55298L11.8446 9.66169L11.0126 10.9098L9.34913 9.80082C8.55952 10.3933 7.4405 10.3933 6.65088 9.80082L4.98744 10.9098L4.1554 9.66169L5.81846 8.55299C5.53922 7.44798 6.16723 6.26073 7.25 5.87803ZM7.25 8C7.25 7.58579 7.58579 7.25 8 7.25C8.41421 7.25 8.75 7.58579 8.75 8C8.75 8.41421 8.41421 8.75 8 8.75C7.58579 8.75 7.25 8.41421 7.25 8Z'
      fill='currentColor'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M1.25 2.42851C1.25 1.7776 1.77766 1.24994 2.42857 1.24994H13.5714C14.2223 1.24994 14.75 1.7776 14.75 2.42851V13.5714C14.75 14.2223 14.2223 14.7499 13.5714 14.7499H2.42857C1.77766 14.7499 1.25 14.2223 1.25 13.5714V2.42851ZM2.75 2.74994V13.2499H13.25V2.74994H2.75Z'
      fill='currentColor'
    />
  </Svg>
);

Safe16.displayName = 'Safe16';
export default Safe16;
